
import { NestedValueExtractor } from "../../general_components/content_management/list_view/listView";

import { TRAILER_ADD_CONF } from "./trailerAddConf";
import { TRAILER_PAGE_OBJECT } from "./trailerPageConf";
import { API_ROOT } from "../../supplementary_components/requests";

const ROOT_PATH = "/trailers/"

// const currentDriversGenerator = (data) => {
//     let result = NestedValueExtractor(data, [["driver1", "firstName"], " / ", ["driver2", "firstName"] ])
//     if (result.slice(result.length-3, result.length) === '/ -'){
//         result = result.slice(0, result.length-3) + NestedValueExtractor(data, [["driver1", "lastName"]])
//     }
//     return result;
// }

export const TRAILER_LISTING_CONF = {
    getRequestLink: API_ROOT+"trailers",
    columnProportions: "1fr 1.3fr 1fr 0.8fr 0.8fr 1.2fr 0.5fr 0.8fr",
    dataTitle: "Trailer",
    dataTitlePlural:"Trailers",
    addButton: true,
    addConf: TRAILER_ADD_CONF,
    minAccessToItemPage: { key: 'TRAILERS', level: 'VIEW' },
    pageConf: new TRAILER_PAGE_OBJECT(),
    category: 'trailers',
    columns: [
        {
            label: "Trailer",
            columnName: "trailerNumber",
            sortable: true,
            identifierColumnName: "id",
            clickable: true,
            path: ROOT_PATH,
        },
        {
            label: "Owned By",
            columnName: "company",
            valueGenerator: (data) => {
                if(data["company"]){
                    return data["company"]["companyName"];
                }else{
                    return "THIRD PARTY TRAILER"
                }
            },
            sortable: true,
            // valueInterpreter: (value) => {                
            //     return value ? value["companyName"]:"THIRD PARTY TRAILER";
            // },
        },
        {
            // Active,
            // OutOfOrder,
            // AtShop,
            // Pending
            label: "Status",
            columnName: "trailerStatus",
            sortable: true,
            clickable: false,
            path: null,
            conditionalFormatting: (value) => {
                if(value === "Active")return `& > * {color:var(--successGreen); font-weight:900; }`;
                let bgColor = "--alert-color";
                if(value === "AtShop" || value === "Pending"){
                    bgColor = "--inProgressYellow";
                }
                return `& > * {color:var(${bgColor}); font-weight:900; }`;
                // return `& > * {color:white; font-weight:600; background:var(${bgColor}); padding: 0.1rem 0.9rem; border-radius:1rem;}`;
            },
            valueInterpreter: (value) => {
                if (value === "AtShop") return "At Shop";
                if (value === "OutOfOrder") return "Out Of Order";
                return value
            },
            alignment:"center",
        },
        {
            label: "Make",
            columnName: "make",
            valueInterpreter: (value) => {
                return value === 'TBA' || value === '' || value === null ? '-' : value;
            }
        },
        {
            label: "Model",
            columnName: "model",
            valueInterpreter: (value) => {
                return value === 'TBA' || value === '' || value === null ? '-' : value;
            }
        },
        {
            label: "Vin",
            columnName: "vin",
            valueInterpreter: (value) => {
                return value === 'TBA' || value === '' || value === null ? '-' : value;
            }
            
        },
        {
            label: "Year",
            notInListView: true,
        },
        {
            label: "License Plate",
            columnName: "licensePlate",
            valueInterpreter: (value) => {
                return value === 'TBA' || value === '' || value === null ? '-' : value;
            }
        },
        {
            label: "Current Truck",
            valueGenerator: (data) => {
                return NestedValueExtractor(data, "currentTruck");
            },
            alignment: "right",
        }
    ]
}
